import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { policyTokenUrl } from "../app.config";

/*
* Dedicated instance for auth/token requests to avoid interceptor conflicts
* */
export const authAxios = axios.create({
  headers: {
    "Content-Type": "application/json",
    clientId: "customer-portal",
    correlationID: uuidv4(),
    Authorization: process.env.REACT_APP_POLICY_BASIC_TOKEN
  },
  withCredentials: true,
});

/*
* key that is going to be used to save and retrieve the token from session storage */
const TOKEN_STORAGE_KEY = "policy_api_token";

/*
*  Get the token from session storage */
export function getStoredToken(): string | null {
  try {
    return sessionStorage.getItem(TOKEN_STORAGE_KEY);
  } catch {
    return null;
  }
}

/*
*   Store the token in session storage */
export function storeToken(token: string | null): void {
  try {
    if (token) {
      sessionStorage.setItem(TOKEN_STORAGE_KEY, token);
    } else {
      sessionStorage.removeItem(TOKEN_STORAGE_KEY);
    }
  } catch {
    // ignore storage errors
  }
}

/*
* return the token from backend response */
function extractToken(data: any): string | null {
  if (!data) return null;
  if (typeof data === "string") return data;
  if (typeof data === "object") {
    // common shapes
    if (data.access_token) return data.access_token as string;
    if (data.token) return data.token as string;
    if (data.data && (data.data.access_token || data.data.token)) {
      return (data.data.access_token || data.data.token) as string;
    }
  }
  return null;
}

/*
* fetch a new token from the backend and store it in session storage */
export async function fetchNewToken(): Promise<string> {
  const url = policyTokenUrl();
  if (!url) throw new Error("Missing REACT_APP_POLICY_TOKEN_URL");

  const response = await authAxios.get(url);

  const token = extractToken(response?.data);
  if (!token) throw new Error("Token not found in get-token response");

  storeToken(token);
  return token;
}

export { TOKEN_STORAGE_KEY };
